



























































































































































































// @ is an alias to /src
import apiFlux from '@/api/flux'
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux';
import { toSubArray, toNumberDictionary, toNumberLookup } from '@/utils/groupBy';
import { AloDiscountRatio, getDefaultAloDiscountRatio } from '@/models/alo/AloDiscountRatio';
import { ItemfluxObjectType } from '@/enum/ItemfluxObjectType';
import { directPayloadQuery } from '@/utils/api';
import { AloBase } from '@/models/alo/AloBase';

@Component({
  name: 'EditDiscountRatio',    
  components:{EditDrawer},   
})
export default class EditDiscountRatio extends Vue {
  
  private headersUni = [
    { text: '', value: 'id',width:30 },
    { text: 'Univers', value: 'libelle' }, 
    { text: '', value: 'selected',width:30 }
  ]

  private headersRub = [
    { text: '', value: 'id',width:10 },
    { text: 'Rubrique', value: 'libelle' },    
    { text: '', value: 'selected',width:30 }
  ]

  private headersFam = [
    { text: '', value: 'id',width:10 },
    { text: 'Famille', value: 'libelle' }    
  ]

  private headersMarque = [
    { text: 'Marque', value: 'mrqId', width:'70%'  },
    { text: 'Remise (%)', value: 'discountRatio', width:'30%'  },    
    { text: '', value: 'action', width:20 },
  ]

  private original:Array<AloDiscountRatio> = []
  private modified:Array<AloDiscountRatio> = []
  private showDrawer = false
  private saving = false   
  private fluxId = -1
  //les id des items selectionnées
  private selectedUnivers = {id:-1}
  private selectedRubrique = {id:-1}

  private showAddMarque = false
  private search = ""

  private marqueTypObj = ItemfluxObjectType.Catalogue
  private marqueDiscountFid = 0

  get allMarquesList(){    
    return this.$store.myGetters.marquesList.filter(m => 
       (!this.search || this.search.length == 0)    
    || (!!this.search && this.search.length > 0 && m.libelle.toLocaleLowerCase().indexOf(this.search.toLocaleLowerCase()) > -1) )
  }
  
  
  edit(items:Array<AloDiscountRatio>,fluxId:number) {    
    this.selectedUnivers = {id:-1}
    this.selectedRubrique = {id:-1}    
    this.fluxId = fluxId
    this.$store.myActions.ADM_FLUX_RESET_STATUS()
    this.showDrawer = true
    this.original = items
    this.modified = cloneDeep(items)    
  }  

  get dicUniDiscountRatio() {
    return toNumberDictionary(this.modified.filter(it => it.itfTypObj == ItemfluxObjectType.Univers && it.mrqId == null),it => it.discountFid)
  }

  get dicRubDiscountRatio() {
    return toNumberDictionary(this.modified.filter(it => it.itfTypObj == ItemfluxObjectType.Rubrique && it.mrqId == null),it => it.discountFid)
  }

  get dicFamDiscountRatio() {
    return toNumberDictionary(this.modified.filter(it => it.itfTypObj == ItemfluxObjectType.Famille && it.mrqId == null),it => it.discountFid)
  }  

  get lookMarqueUnivers() {
    return toNumberLookup(this.modified.filter(it => it.itfTypObj == ItemfluxObjectType.Univers && it.mrqId != null),it => it.discountFid)
  }

  get lookMarqueRubrique() {
    return toNumberLookup(this.modified.filter(it => it.itfTypObj == ItemfluxObjectType.Rubrique && it.mrqId != null),it => it.discountFid)
  }

  get lookMarqueFamille() {
    return toNumberLookup(this.modified.filter(it => it.itfTypObj == ItemfluxObjectType.Famille && it.mrqId != null),it => it.discountFid)
  }

  get dicUniChildSelected() {
    return this.modified.reduce((acc,it) => {
      if(it.itfTypObj == ItemfluxObjectType.Rubrique) acc[this.rubriques[it.discountFid].uniId] = true
      else if(it.itfTypObj == ItemfluxObjectType.Famille) acc[this.familles[it.discountFid].uniId] = true
      return acc
    },{} as {[index:number]:boolean}) 
  }

  get dicRubChildSelected() {
    return this.modified.reduce((acc,it) => {      
      if (it.itfTypObj == ItemfluxObjectType.Famille) acc[this.familles[it.discountFid].rubId] = true
      return acc
    },{} as {[index:number]:boolean})
  }


  get title() {
    return "Définition des remises par catégories / marques"
  }

  get isDirty() {
    return !deepEqual(this.original,this.modified)
  }

  get fluxStatus() {
    return this.$store.myGetters.fluxStatus
  }

  get universList(){
    return this.$store.myGetters.universList
  }

  get rubriques(){
    return this.$store.myGetters.rubriques
  }

  get rubriquesList(){
    return this.$store.myGetters.rubriquesList
  }

  get familles(){
    return this.$store.myGetters.familles
  }

  get famillesList(){
    return this.$store.myGetters.famillesList
  }

  get displayUnivers() {
    return this.universList.map(it => {
      return {
        id:it.id,
        libelle:it.libelle,
        selected:!!this.dicUniDiscountRatio[it.id],
        childSelected:!!this.dicUniChildSelected[it.id],
        parentSelected:false,
        discountItem:this.dicUniDiscountRatio[it.id]??null
      }
    })
  }

  get marques() {
    return this.$store.myGetters.marques
  }

  get displayRubrique() {
    return this.rubriquesList.filter(r => r.uniId == this.selectedUnivers.id).map(it => {
      return {
        id:it.id,
        libelle:it.libelle,
        selected:!!this.dicRubDiscountRatio[it.id],
        childSelected:!!this.dicRubChildSelected[it.id],
        parentSelected:!!this.dicUniDiscountRatio[it.uniId],
        discountItem:this.dicRubDiscountRatio[it.id]??null,
        parentRatio:this.dicUniDiscountRatio[it.uniId]?.discountRatio ?? null
      }
    })
  }

  get displayFamille() {
    return this.famillesList.filter(f => f.rubId == this.selectedRubrique.id).map(it => {
      return {
        id:it.id,
        libelle:it.libelle,
        selected:!!this.dicFamDiscountRatio[it.id],
        childSelected:false,
        parentSelected:!!this.dicUniDiscountRatio[it.uniId] || !!this.dicRubDiscountRatio[it.rubId],
        parentRatio: this.dicRubDiscountRatio[it.rubId]?.discountRatio ?? this.dicUniDiscountRatio[it.uniId]?.discountRatio ?? null
      }
    })
  }

  created(){
    this.$store.myActions.CATALOGUE_TREE_ENSURE()
  }

  selectUnivers(item: any) {
    if(item.id != this.selectedUnivers.id) this.selectedRubrique = {id:-1}
    this.selectedUnivers = item    
  }

  selectRubrique(item: any) {
    this.selectedRubrique = item
  }


  updateUnivers(id:number,selected:boolean) {
    if(selected) {
      this.modified.push({
        ...getDefaultAloDiscountRatio(),
        flxId:this.fluxId,
        itfTypObj:ItemfluxObjectType.Univers,
        discountFid:id
      })
    }
    else{
      this.modified.splice(this.modified.findIndex(it => it.discountFid == id && it.itfTypObj == ItemfluxObjectType.Univers && it.mrqId == null),1)
    }
  }

  updateRubrique(id:number,selected:boolean){    
    if(selected) {
      this.modified.push({
        ...getDefaultAloDiscountRatio(),
        flxId:this.fluxId,        
        itfTypObj:ItemfluxObjectType.Rubrique,
        discountFid:id
      })
    }
    else{
      this.modified.splice(this.modified.findIndex(it => it.discountFid == id && it.itfTypObj == ItemfluxObjectType.Rubrique && it.mrqId == null),1)
    }
  }

  updateFamille(id:number,selected:boolean){
    if(selected) {
      this.modified.push({
        ...getDefaultAloDiscountRatio(),
        flxId:this.fluxId,        
        itfTypObj:ItemfluxObjectType.Famille,
        discountFid:id
      })
    }
    else{
      this.modified.splice(this.modified.findIndex(it => it.discountFid == id && it.itfTypObj == ItemfluxObjectType.Famille && it.mrqId == null),1)
    }
  }

  addUniversMarque(id:number){
    this.addMarque(id,ItemfluxObjectType.Univers)
  }
  addRubriqueMarque(id:number){
    this.addMarque(id,ItemfluxObjectType.Rubrique)
  }
  addFamilleMarque(id:number){
    this.addMarque(id,ItemfluxObjectType.Famille)
  }

  selectMarque(marque:AloBase){
    this.showAddMarque = false
    this.modified.push({
        ...getDefaultAloDiscountRatio(),
        flxId:this.fluxId,        
        itfTypObj:this.marqueTypObj,
        discountFid:this.marqueDiscountFid,
        mrqId:marque.id
      })
  }

  addMarque(id:number,itfTypObj:ItemfluxObjectType) {    
    this.showAddMarque = true
    this.marqueDiscountFid = id
    this.marqueTypObj = itfTypObj
  }  
  saveData() {        
    this.saving = true
    directPayloadQuery(apiFlux.saveDiscountRatio,{id:this.fluxId,discountItems:this.modified},this.$store).then((items)=>{
      this.original.splice(0,this.original.length,...items)
      this.showDrawer = false
    }).finally(() => {
      this.saving = false
    })     
  }

  deleteDiscountRatio(item:any) {    
    console.log(item)
      const idx = this.modified.findIndex(it => it.mrqId == item.mrqId && it.itfTypObj == item.itfTypObj && it.discountFid == item.discountFid  )     
      if(idx > -1)  {        
        this.modified.splice(idx,1)          
      }        
  }

  
}
